export class FileToDelete {
    path: string;
    isADir: boolean;

    constructor(path: string, isADir: boolean) {
        this.path = path;
        this.isADir = isADir;
    }
}
